// sliders
$(document).ready(function(){
  $('.tabs .tab .btn').click(function(){
    $(this).parent('.tabs .tab').addClass('active').siblings().removeClass('active');
    const siblings_elems = $(this).parent().parent().siblings()
    $(siblings_elems).each(function() {
      $(this).find("*").removeClass('active')
    });
    const image_elems = $(this).parent().parent().parent().parent().siblings()
    $(image_elems).each(function() {
      $(this).find("*").removeClass('active')
    });
    var t_id = $(this).data('nav');
    console.log('t_id'+t_id);
    $(t_id).addClass('active');
  });


  var action="click";
  var speed="500";
  $('.faq_qus').on(action, function() {
    $(this).toggleClass('active')
    $(this).next()
    .slideToggle(speed)
    .siblings('.faq_ans')
    .slideUp();
  });
  
  var recomm_loaded = setInterval(function(){
    if($(".product-recommendations .product-single__related").length >= 1){ console.log('recomm_loaded');
      clearInterval(recomm_loaded);
      $(".product-recommendations .product-single__related").slick({
        arrows:!0,infinite:!0,speed:300,slidesToShow:3,slidesToScroll:1,autoplay: true,
        responsive:[
          {breakpoint:1024,settings:{slidesToShow:3,slidesToScroll:1,infinite:!0,arrows:!0}},
          {breakpoint:769,settings:{slidesToShow:1,slidesToScroll:1,centerMode:!0}}
        ]
      });
    }
  }, 1000);
  
  
  
  $(".product_slider").slick({
    arrows:!0,infinite:!0,speed:300,slidesToShow:4,slidesToScroll:1,autoplay: true,
    responsive:[
      {breakpoint:1024,settings:{slidesToShow:3,slidesToScroll:1,infinite:!0,arrows:!0}},
      {breakpoint:769,settings:{slidesToShow:1,slidesToScroll:1,centerMode:!0}}
    ]
  });
  
  
  $('.slider-for').each(function(key, item){
    var sliderIdName = 'slider' + key;
    var sliderNavIdName = 'sliderNav' + key;

    this.id = sliderIdName;
    $('.slider-nav')[key].id = sliderNavIdName;

    var sliderId = '#' + sliderIdName;
    var sliderNavId = '#' + sliderNavIdName;

    $(sliderId).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: sliderNavId
    });

    $(sliderNavId).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical:true,
      asNavFor: sliderId,
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true,
      verticalSwiping:true,
       responsive: [
        {
          breakpoint: 1024,
          settings: {
            vertical:false,
           verticalSwiping:false,
          }
        }
       ]
    });
  });
    
  var acc = document.getElementsByClassName("accordion");
  var i;
  for (i = 0; i < acc.length; i++) {

    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
		
      var els = document.getElementsByClassName("panel");
      [].forEach.call(els, function (el) {
        el.style.maxHeight = null;
      });
      
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.getElementsByTagName('input')[0].checked = true;
      } 
    });
  }
  
//   $('.shop-box').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     mobileFirst: true,
//     dots: false,
//     arrows: false,
//     centerMode: false,
//     focusOnSelect: true,
//     responsive: [
//       {
//         breakpoint: 480,
//       	settings: "unslick"
//       }
//     ]
//   });
  
  //product specification slider
  $(".spec-slider").on("click",function(event){
    $('html,body').animate({scrollTop: $(".product_feat_tab-section").offset().top},2000);
  });
  
  
  
  $('.size-guide-pop a').click(function(){
    $(".popup-overlay, .popup-content").addClass("active");
  });

  $(".close, .popup-overlay").on("click", function(){
    $(".popup-overlay, .popup-content").removeClass("active");
  });

  $(".custom_mega").hover(
    function() {
      $("#SiteHeader").css("background-color","#ffffff");
       $(this).find('.custom_effect').show();
    }, function() {
      $("#SiteHeader").css("background-color","#f6f6f6");
    }
  );
  
  $(".custom_effect").hover(
    function() {
       $(".custom_effect").hide();
      $(".shop-all-megamenu").hide();
    }, function() {
//      $(".custom_effect").hide();
      $(".shop-all-megamenu").hide();
    }
  );
  
  
});
$(document).ready(function(){
  if ($(window).width() <= 480 ) {
    $('.moble-prod-slider, .testimonials-block').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed:300,
      centerMode:true
    });
  }
  $(window).on('resize', function(){
    var win = $(this); //this = window
    if (win.height() <= 480) {
      if (!$('.moble-prod-slider, .testimonials-block').hasClass('slick-initialized')) {
        $('.moble-prod-slider, .testimonials-block').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed:300,
          centerMode:true
        });
      }
    } else {
      if (!$('.moble-prod-slider, .testimonials-block').hasClass('slick-initialized')) {
        $('.moble-prod-slider, .testimonials-block').slick('unslick')
      }
    } 
});
})


